export const BUSINESS_MANDATE = [
  { label: 'Any 1', value: '1' },
  { label: 'Any 2', value: '2' },
  { label: 'Any 3', value: '3' }
];

export const BUSINESS_MANDATE_ACCOUTS = [
  { label: 'This account only', value: 'N' },
  { label: 'This account plus any accounts opened in the future', value: 'Y' }
];
